module.exports = __webpack_public_path__ + "img/exam_jan_2025_7uk3hoe5.6a3c183e.jpg";